import { Currency } from 'core/agency/Agency';
import { Pagination } from 'core/pagination/Pagination';

export type StoredValueAgencyRecordsWithPagination = {
  pagination: Pagination,
  records: StoredValueAgencyRecord[]
};

export type StoredValueLog = {
  storedValueId: number,
  adAgencyId: number,
  vendorNumber: string,
  amount: number,
  description: string,
  comment: string,
  createTime: string,
  adAgencyName: string,
  currency: Currency,
  remain: number,
  action: StoredValueAction
};

export type StoredValueAgencyRecord = {
  adAgencyId: number,
  vendorNumber: string,
  supplierName: string,
  currency: Currency,
  remain: number,
  totalAmount: number,
  remainingAmount: number,
  usedAmount: number
  action: StoredValueAction
};

/**
 * 後端算好的儲值額度。對應後端的 `StoredValueTotalReadDTO`，被兩支 endpoint 共用；
 * 後端是 `@JsonInclude(NON_NULL)`，各只回自己那一個金額，所以兩個金額欄位都是 optional：
 *
 * - `GET /stored-value/{agencyId}/remaining-amount` -> 只有 `remainingAmount`
 * - `GET /stored-value/{agencyId}/frozen-amount`    -> 只有 `frozenAmount`
 *
 * 這兩個數字後端算的時候**不因呼叫者身分過濾任何 action**（含 RECONCILE_ADJUST 弭平扣除），
 * 所以是正確的；前端不可拿明細清單自己加總（清單對供應商隱藏了弭平那一列，餘額會偏高）。
 *
 * ⚠️ `remaining-amount` 是 PChome 的**對外 open API**，欄位集合不為了後台顯示而擴充
 * （已用 / 總儲值維持前端自算，見 `StoredValueDetailModel`）。
 */
export type StoredValueTotal = {
  adAgencyId: number,
  adAgencyName: string,
  currency: Currency,
  remainingAmount?: number,
  frozenAmount?: number
};

export type StoredValueSummary = {
  adAgencyId: number,
  vendorNumber: string,
  adAgencyName: string,
  currency: Currency,
  stored: number,
  used: number,
  remain: number,
  freezed: number,
  logs: StoredValueLog[]
};

export enum StoredValueAction {
  RECHARGE = 'RECHARGE',
  EDIT_BUDGET = 'EDIT_BUDGET',
  CREATE_ORDER = 'CREATE_ORDER',
  EDIT_ORDER = 'EDIT_ORDER',
  SETTLE_ORDER = 'SETTLE_ORDER',
  FREEZE_BUDGET = 'FREEZE_BUDGET',
  UNFREEZE_BUDGET = 'UNFREEZE_BUDGET',
  REMOVE_FREEZE_BUDGET = 'REMOVE_FREEZE_BUDGET',
  // 弭平扣除（調整儲值額度）。amount 為負，餘額語意比照訂單類扣款。
  // 只有 TenMax 系統管理員拿得到這種紀錄，後端已對供應商 / PChome API 過濾掉。
  RECONCILE_ADJUST = 'RECONCILE_ADJUST'
}
